module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA9BAMAAADsTHzaAAAAFVBMVEVHcEy1tra3t7e2tra1tra1tra1trbAPFa8AAAABnRSTlMA7zk0wmo+yJByAAABEUlEQVQ4y4WVQRKCMAxFA6hrhZG1jBeA8QKuXOsNZMbJ/Y8g1FJb+j9hR8J70ya0EbGe16cnmepxFtmr1iTfqT6lUB0vMF22qkc5KBNM+JTfKRHMuN6laolgxsdp6QMWlAtHBF3AoCCioCCGgCBhgCBFMsGKyARrYPWefb8K5AsefDHZel2ooXgigPWKBLhhQUD6FQSk34uA/i9ewHAvuLX0f3WCE8V/AlV+XpyA44ugpkfVCThu5g2/tT5jf1Z9XH2vtL6+cbQ/PsH6G+JEEMJYEEWhIAoiQRIDgiSUC6zzaZxv634w7hewoS4mwH7KCIEFjQSwnn/B1v3cy/b93og5H6z5UmzOp7c536z5aMzXL8Pnsz3sGnBZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/close.png
// module id = pHLi
// module chunks = 1